var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","float":"left"}},[(_vm.widget.data.name==='mobileInquiryResult')?_c('mobile-inquiry-result',{attrs:{"widget":_vm.widget.data}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }